import InteractionScheme from './InteractionScheme'

export default InteractionScheme;